import {
	IN_CAMPAIGN_FILTER_NAME,
	IN_CAMPAIGN_FILTER_OPERATORS,
	IN_CAMPAIGN_FILTER_PARAM,
} from "@signalist/shared-types";

import { FilterCategory } from "../enums/filter.enum";

import type { IFilter } from "./filter-types";

/**
 * "In campaign" (PREC-4163): is the person confirmed in a campaign on any list the user may see.
 * One definition for every lead catalog (general, Jobs, Maps), so the modal shows it once and the
 * API answers it the same way everywhere. Stored under the key of the former "Assigned to".
 */
export const inCampaign: IFilter = {
	name: IN_CAMPAIGN_FILTER_NAME,
	filterParam: IN_CAMPAIGN_FILTER_PARAM,
	filterByType: [...IN_CAMPAIGN_FILTER_OPERATORS],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};
